module.exports = __webpack_public_path__ + "static/media/trash.cfafb05f.svg";